export function angkaTerbilang(angka) {
  if (typeof angka !== 'number') return '';
  const huruf = [
    '', 'Satu', 'Dua', 'Tiga', 'Empat', 'Lima', 'Enam', 'Tujuh', 'Delapan', 'Sembilan', 'Sepuluh', 'Sebelas'
  ];
  let temp = '';

  if (angka < 12) {
    temp = ' ' + huruf[angka];
  } else if (angka < 20) {
    temp = angkaTerbilang(angka - 10) + ' Belas';
  } else if (angka < 100) {
    temp = angkaTerbilang(Math.floor(angka / 10)) + ' Puluh' + angkaTerbilang(angka % 10);
  } else if (angka < 200) {
    temp = ' Seratus' + angkaTerbilang(angka - 100);
  } else if (angka < 1000) {
    temp = angkaTerbilang(Math.floor(angka / 100)) + ' Ratus' + angkaTerbilang(angka % 100);
  } else if (angka < 2000) {
    temp = ' Seribu' + angkaTerbilang(angka - 1000);
  } else if (angka < 1000000) {
    temp = angkaTerbilang(Math.floor(angka / 1000)) + ' Ribu' + angkaTerbilang(angka % 1000);
  } else if (angka < 1000000000) {
    temp = angkaTerbilang(Math.floor(angka / 1000000)) + ' Juta' + angkaTerbilang(angka % 1000000);
  } else if (angka < 1000000000000) {
    temp = angkaTerbilang(Math.floor(angka / 1000000000)) + ' Miliar' + angkaTerbilang(angka % 1000000000);
  } else if (angka < 1000000000000000) {
    temp = angkaTerbilang(Math.floor(angka / 1000000000000)) + ' Triliun' + angkaTerbilang(angka % 1000000000000);
  }

  return temp;
}

export function terbilangRupiah(angka) {
  if (!angka || isNaN(angka)) return 'Nol Rupiah';
  let hasil = angkaTerbilang(Math.round(angka)).trim();
  return hasil ? hasil + ' Rupiah' : 'Nol Rupiah';
}
